import styled from 'styled-components'

import { ClinTheme } from '../../ClinTheme'
import { mediaQueryDown } from '../../utils/mediaQuery'
import {
  StyledOrderDetailItem,
  StyledOrderDetailItemDivider
} from '../OrderPages/OrderDetail/OrderDetailItem.styles'

const mediumUpBreakpoint = ClinTheme.breakpoints[1]

export const StyleOpaAction = styled.div({
  display: 'flex',
  cursor: 'pointer'
})

export const StyledMaOrderDetailsButtonsGroup = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  [`.clin-button`]: {
    marginLeft: ClinTheme.space[4]
  },
  [mediaQueryDown(mediumUpBreakpoint)]: {
    flexDirection: 'column',
    flexWrap: 'wrap',
    [`.clin-button`]: {
      width: '100%',
      marginLeft: ClinTheme.space[0],
      marginTop: ClinTheme.space[3]
    }
  }
})

export const StyledOrderDetail = styled.div({
  [`${StyledOrderDetailItem}:last-of-type`]: {
    [`${StyledOrderDetailItemDivider}`]: {
      display: 'none'
    }
  }
})

export const StyledDetailsContainer = styled.div({
  display: 'flex',
  padding: ClinTheme.space[4],
  backgroundColor: ClinTheme.colors.white
})

export const StyledDetailsItem = styled.div({
  flex: 1,
  paddingLeft: ClinTheme.space[4],
  borderRight: `1px solid ${ClinTheme.colors.midGrey}`,

  ':first-child': {
    paddingLeft: 0
  },

  ':last-child': {
    borderRight: 0
  }
})
